import { fromPairs } from 'lodash';

if (!Object.fromEntries) Object.fromEntries = fromPairs;
